import { render } from "./test-series-index.vue?vue&type=template&id=b3648e00"
import script from "./test-series-index.vue?vue&type=script&lang=js"
export * from "./test-series-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__